import { FC } from "react";
import { Box, Paper, Stack, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import { useTeam } from "../hooks/useTeam.ts";
import { TeamLogo } from "./TeamLogo.tsx";
import { TeamName } from "./TeamName.tsx";

interface TeamCardProps {
  teamId: string;
  to?: string;
}

export const TeamCard: FC<TeamCardProps> = ({ teamId, to }) => {
  const teamData = useTeam(teamId);

  const primaryColor = teamData.data?.primaryColor ?? "#000000";

  return (
    <Paper
      component={to ? Link : undefined}
      to={to}
      style={{
        cursor: to ? "pointer" : "default",
        overflow: "hidden",
        textDecoration: "none",
        color: "inherit",
      }}
      withBorder
      radius="md"
    >
      <Stack p="sm" gap={8} align="center">
        <TeamLogo teamId={teamId} height={60} />
        <Text fw={600} ta="center" size="sm" lineClamp={1}>
          <TeamName teamId={teamId} variant="medium" />
        </Text>
      </Stack>
      <Box h={4} bg={primaryColor} />
    </Paper>
  );
};
